import baseClasses from '@components/Themes/layout.module.scss'
import { Icon as YesIcon } from '@iconify/react'
import whatsappComponentmodulescss from 'dist/css/whatsappComponent.module.scss'
import React, { FunctionComponent } from 'react'

const AptugoComponent: FunctionComponent<any> = (props) => {
  const theme = { ...baseClasses, ...whatsappComponentmodulescss }

  // Theme selection

  return (
    <React.Fragment>
      <div data-title="div Whatsapp" className={theme.whatsapp}>
        <a target="_blank" href="https://wa.me/+56984531583" draggable={false}>
          <YesIcon icon="logos:whatsapp-icon" />
        </a>
      </div>
    </React.Fragment>
  )
}

export default AptugoComponent
